import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-grid',
  templateUrl: './video-grid.component.html',
  styleUrls: ['./video-grid.component.scss']
})
export class VideoGridComponent implements OnInit {
  videos = [
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    },
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    },
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    },
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    },
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    },
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    },
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    },
    {
      "thumbnail": "https://i.cbc.ca/1.2438413.1385303367!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/saskatchewan-roughriders-hamilton-tiger-cats.jpg",
      "title": "Boys Basketball: Elida vs Bath",
      "startTime": "6:00 PM",
      "location": "Elida Fieldhouse"
    }
  ]

  constructor() { }

  ngOnInit() {
  }

}
